<template lang="pug">
  modal(:active='active' title='Solicitação de Prazo' @close="$emit('close')")
    div(slot='modal-body')
      .columns.py-2
        item-col.my-1.col-auto.col-sm-6(
          label='ordem_servico_solicitacao.ordem_servico'
          :value="`${solicitacao.ordem_servico.numero}/${solicitacao.ordem_servico.ano}`"
        )
        item-col.my-1.col-auto.col-sm-6(
          label='ordem_servico_solicitacao.usuario_solicitou'
          :value='solicitacao.usuario_solicitou.nome'
        )
        item-col.my-1.col-auto.col-sm-6(
          label='ordem_servico_solicitacao.solicitado_concluir_em'
          :value="solicitacao.solicitado_concluir_em | date('DD/MM/YYYY')"
        )
        item-col.my-1.col-auto.col-sm-6(
          label='ordem_servico_solicitacao.situacao'
          :value="solicitacao | enums('ordem_servico_solicitacao.situacao')"
        )
        item-col.my-1.col-12(
          label='ordem_servico_solicitacao.motivo_solicitado'
          :value='solicitacao.motivo_solicitado'
        )
        item-col.my-1.col-auto.col-sm-6(
          label='ordem_servico_solicitacao.autorizado_em'
          :value='solicitacao.autorizado_em | date'
          v-if='solicitacao.autorizado_em'
        )
        item-col.my-1.col-auto.col-sm-6(
          label='ordem_servico_solicitacao.autorizado_concluir_em'
          :value='solicitacao.autorizado_concluir_em | date("DD/MM/YYYY")'
          v-if='solicitacao.autorizado_concluir_em'
        )
        item-col.my-1.col-12(
          label='ordem_servico_solicitacao.motivo_recusado'
          :value='solicitacao.motivo_recusado'
          v-if='solicitacao.motivo_recusado'
        )
      div(v-if='permitActions')
        .form-group
          label.form-radio.form-inline
            input(type='radio' name='acao' v-model='acao' value='autorizar')
            i.form-icon
            | &nbsp; Autorizar
          label.form-radio.form-inline
            input(type='radio' name='acao' v-model='acao' value='recusar')
            i.form-icon
            | &nbsp; Recusar
        form-group(
          :label="'ordem_servico_solicitacao.motivo_recusado' | tModel"
          :validation="$v.params.recusar.motivo_recusado"
          v-if='isRecusar'
        )
          input.form-input(v-model="$v.params.recusar.motivo_recusado.$model")
        form-group(
          :label="'ordem_servico_solicitacao.autorizado_concluir_em' | tModel"
          :validation="$v.params.autorizar.autorizado_concluir_em"
          v-if='isAutorizar'
        )
          datepicker(v-model="$v.params.autorizar.autorizado_concluir_em.$model")
    div(slot='modal-footer' v-if='permitActions')
      button.btn.btn-primary(
        :class="{'loading': loading}"
        @click='onRecusar'
        :disabled='$v.params.recusar.$invalid || loading'
        v-if='isRecusar'
      )
        btn-content(name='save' label='Recusar')
      button.btn.btn-primary(
        :class="{'loading': loading}"
        @click='onAutorizar'
        :disabled='$v.params.autorizar.$invalid || loading'
        v-if='isAutorizar'
      )
        btn-content(name='save' label='Autorizar')
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  props: {
    solicitacao: { type: Object, required: true },
    active: { type: Boolean, required: true },
  },

  vuex: {
    solicitacoes: {
      getters: ['loading'],
      actions: ['fetchAutorizar', 'fetchRecusar'],
    },
  },

  computed: {
    permitActions() {
      return this.solicitacao.situacao === 'solicitado'
    },
    isRecusar() {
      return this.acao === 'recusar'
    },
    isAutorizar() {
      return this.acao === 'autorizar'
    },
  },

  data() {
    return {
      acao: '',
      params: {
        autorizar: {
          autorizado_concluir_em: null,
        },
        recusar: {
          motivo_recusado: '',
        },
      },
    }
  },

  methods: {
    onAutorizar() {
      this.fetchAutorizar({
        id: this.solicitacao.id,
        params: this.params.autorizar,
      })
        .then(res => {
          this.$toaster.success('Autorizado com sucesso.')
          this.$emit('close', res)
        })
        .catch(e => {
          this.$toaster.error(e.message)
        })
    },

    onRecusar() {
      this.fetchRecusar({
        id: this.solicitacao.id,
        params: this.params.recusar,
      })
        .then(res => {
          this.$toaster.success('Recusado com sucesso.')
          this.$emit('close', res)
        })
        .catch(e => {
          this.$toaster.error(e.message)
        })
    },
  },

  mounted() {
    this.params.autorizar.autorizado_concluir_em = this.solicitacao.solicitado_concluir_em
  },

  validations: {
    params: {
      autorizar: {
        autorizado_concluir_em: { required },
      },
      recusar: {
        motivo_recusado: {
          required,
          minLength: minLength(5),
          maxLength: maxLength(100),
        },
      },
    },
  },
}
</script>
